<template>
  <div class="page-header">
    <div class="header-back-wrap"><slot name="back"></slot></div>
    <div class="title-wrap">
      <slot name="title">
        <h4 class="title">{{ $t(title) }}</h4>
      </slot>
    </div>
    <div class="handles-wrap"><slot></slot></div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'title'
    }
  }
}
</script>

<style lang="less" scoped>
@import '../style/variable.less';

.page-header {
  background-color: @pageHeaderColor;
  height: @pageHeaderHeight;
  border-bottom: 1px solid @lineColor;
  display: flex;
  .title-wrap {
    height: 100%;
    width: 160px;
    padding-left: 20px;
    display: flex;
    align-items: center;
    .title {
      font-size: 16px;
      font-weight: normal;
      line-height: 1;
      color: #000;
    }
  }
  .handles-wrap,
  .header-back-wrap {
    display: flex;
    align-items: center;
    .back {
      width: 80px;
      height: calc(100% - 20px);
      font-size: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-right: 1px solid @lineColor;
    }
  }
}
</style>
